module.exports = __webpack_public_path__ + "static/img/point_close.00b1fe5c.png";